import request from '@/utils/request';
export function getEntries(data) {
  return request({
    url: 'analysis-chat/get-entries',
    method: 'get',
    params: data
  });
}
export function addOrUpdateEntry(data) {
  return request({
    url: 'analysis-chat/add-or-update-entry',
    method: 'post',
    params: data
  });
}
export function reviewEntry(data) {
  return request({
    url: 'analysis-chat/review-entry',
    method: 'post',
    params: data
  });
}
export function publishEntry(data) {
  return request({
    url: 'analysis-chat/publish-entry',
    method: 'post',
    params: data
  });
}
export function rollbackEntry(data) {
  return request({
    url: 'analysis-chat/rollback-entry',
    method: 'post',
    params: data
  });
}
export function disableEntry(data) {
  return request({
    url: 'analysis-chat/disable-entry',
    method: 'post',
    params: data
  });
}
export function getReviews(data) {
  return request({
    url: 'analysis-chat/get-reviews',
    method: 'get',
    params: data
  });
}
export function healthCheck(data) {
  return request({
    url: 'analysis-chat/health_check',
    method: 'get',
    params: data
  });
}
export function publishRecords(data) {
  return request({
    url: 'analysis-chat/publish_records',
    method: 'get',
    params: data
  });
}